export const GET_USERS = 'GET_USERS';
export const SET_USERS = 'SET_USERS';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_USER = 'SET_USER';
export const ADD_USER = 'ADD_USER';
export const EMPTY_USER = 'EMPTY_USER';
export const DELETE_USER = 'DELETE_USER';
export const EDIT_USER = 'EDIT_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const SET_USER_FILTER = 'SET_USER_FILTER';